import React, { useState } from "react";
import {PermissionPathContext} from "./context";

const PermissionPathProvider: React.FC = ({children}) => {
	const [permissionPath, setPermissionPath] = useState<string | undefined>(undefined);
	const changePermissionPath = (path: string | undefined) => { setPermissionPath(path); };

	return <PermissionPathContext.Provider value={{
		permissionPath,
		changePermissionPath
	}}>
		{children}
	</PermissionPathContext.Provider>;
};

export default PermissionPathProvider;
